export const BUSINESS_NAME = 'Kjergaard Sports'
export const PHONE = '507-368-4696'
export const PHONE_TEL = 'tel:507-368-4696'
export const ADDRESS_LINE_1 = '1951 200th Avenue'
export const ADDRESS_LINE_2 = 'Lake Benton, Minnesota 56149'
export const GOOGLE_MAPS_URL =
  'https://maps.google.com/?q=1951+200th+Avenue+Lake+Benton+Minnesota+56149'
export const FACEBOOK_URL =
  'https://www.facebook.com/profile.php?id=100057537217940'
export const WEBSITE_URL = 'https://www.ksportsllc.com/'
